import { render } from "./Temperament.vue?vue&type=template&id=1116acc2"
import script from "./Temperament.vue?vue&type=script&lang=js"
export * from "./Temperament.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__